/**
 * Which machines the equipment picker can list, as a translation key.
 *
 * Installation work orders are the interesting case: what they may name depends on
 * the tenant's `installationRequiresUnassignedAsset` flag, so a single
 * installation message would be wrong in one of the two configurations.
 */
export function assetsTooltipKey(
  interventionType: string,
  requiresUnassignedAsset: boolean,
): string {
  if (interventionType !== 'INSTALLATION') {
    return 'EQUIPMENTS_SELECTOR_TOOLTIP_COMPANY';
  }

  return requiresUnassignedAsset
    ? 'EQUIPMENTS_SELECTOR_TOOLTIP_INSTALLATION_UNASSIGNED'
    : 'EQUIPMENTS_SELECTOR_TOOLTIP_INSTALLATION_BOTH';
}
